import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const AutoReplenishmentOverviewPage = lazy(
  () =>
    import(
      "../../../../components/WMS/AutoReplenishment/AutoReplenishmentOverviewPage.tsx"
    ),
)

export const Route = createFileRoute(
  "/_layout/WMS/auto-replenishment/overview",
)({
  component: AutoReplenishmentOverviewRoute,
})

function AutoReplenishmentOverviewRoute() {
  return (
    <LazyRoutePage>
      <AutoReplenishmentOverviewPage />
    </LazyRoutePage>
  )
}
